import React, { useEffect, useState, MouseEvent } from "react";
import {
  ISearchableChecklist,
} from "../../../../../yoello-lib/modules/components/UI/Lists/SearchableChecklist";
import { ReactComponent as EditIcon } from "../../../../../assets/images/icon-edit.svg";
import { useTranslation } from "react-i18next";
import ListLoading from "../../../../util/Loading";
import { APIExtensions } from "../../../../../yoello-lib/modules/API2/types";
import { useProductsData } from "../../useProductsData";
import IMenuItemBody from "../../../../../interfaces/IMenuItemBody";
import { PriceOptionDetailsTooltip } from "./PriceOptionDetailsTooltip";
import { ISearchableChecklistItem } from "../../../../../yoello-lib/modules/components/UI/Lists/SearchableChecklist/SearchableChecklistItem";
import { IMultiDialogChildren } from "../../../../dialogRoutes/MultiDialogRoute";
import { useDialogRouteStages } from "../../../../dialogRoutes/useDialogRouteStages";
import { dialogKeys } from "../../../../../const/URL.const";
import AdvancedChecklist from "../../../../../yoello-lib/modules/components/UI/Lists/AdvancedChecklist";
import { useDialogClose } from "../../../../dialogRoutes/useDialogClose";
import {isObjectEmpty} from "../../../../../utils/objectCheck";
import { FormLoadingWrapper } from "../../../../util/FormLoadingWrapper";
interface IAddExtrasFormDialogProps extends ISearchableChecklist, IMultiDialogChildren {
  // dialogProps: {
  onClose: (prevData?: any) => void;
  onSubmit: (selectedItems: any) => void;
  onDataChange?: () => void;
  selectedItems?: [];
  isLoading?: boolean;
  items: any[];
  contentTemplate?: (item: any) => React.ReactNode;
  showTooltip?: boolean,
  toolTipContent?: string | React.ReactNode,
  APIDefintion: APIExtensions;
  venueId: string;
  goToProductModal?: (item: any, selectedItems: ISearchableChecklistItem[]) => void;
  isSquare: boolean,
  hasToolbar: boolean,
  ToolbarComponent?: React.ReactElement,
  contentClassName?: string,
  showOnlyMainItems?: boolean
  nextKey: string;
  nextURL: string;
  noSortApi?: boolean
  preQuery?: string
  queryParams?: string
  propNameToDisplay?: string,
  // };
}
export function checkIsOnlyMainItem(item: any) {
  return (isObjectEmpty(item.pricing_options_extras));
}
export function AddExtrasFormDialog(props: IAddExtrasFormDialogProps) {
  const { t } = useTranslation();
  const [Items, setItems] = useState<any>([]);
  const [listItems, setListItems] = useState<any>([]);
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const { setProps, goToNextStep, getProps } = useDialogRouteStages(props.history);
  console.log({ props });
  const { isLoading } = useProductsData<any>(
    //@ts-ignore
    props?.APIDefinition, props.venueId, setListItems, props.noSortApi ? {} : { 'sort_field': 'sort_position' }, props.queryParams, props.preQuery);
  useDialogClose(props);
  useEffect(() => {
    if (Array.isArray(listItems) && listItems.length > 0) {
      let items = listItems;

      if (props.showOnlyMainItems) {
        items = items.filter(item => !item.sold_as_extra_only && Object.values(item.pricing_options).length>0)
      }
      setProps(dialogKeys.EXTRAGROUP, "menuItems", listItems);
      setItems(items);
    }
    // eslint-disable-next-line
  }, [listItems, selectedItems]);
  useEffect(() => {
    const { selectedItems } = getProps(props.dialogKey);
    if (selectedItems && selectedItems.length > 0) {
      setSelectedItems(selectedItems);
    }
    // eslint-disable-next-line
  }, [props.selectedItems?.length]);
  function Toolbar(id: string, getSelected: () => ISearchableChecklistItem[]) {
    if (props.ToolbarComponent) {
      return props.ToolbarComponent
    } else {
      let menuItem: IMenuItemBody | null = null;
      if (Array.isArray(listItems)) {
        menuItem = listItems.filter((item: IMenuItemBody) => {
          return item.id === id;
        })[0];
      }
      const onClickEdit = (
        event: MouseEvent<SVGSVGElement>,
      ) => {
        event.stopPropagation();
        const selectedItems: ISearchableChecklistItem[] = getSelected();
        //items that selected but not submited yet should be in 
        setProps(props.dialogKey, "selectedItems", selectedItems);
        if (menuItem) {
          const item = menuItem.details ? menuItem.details : menuItem;
          goToNextStep(props.nextKey, {
            ComponentProps: {
              item,
              selectedItems,
              removeSelectedItem: (id: string) => {
                const filteredArray = [...selectedItems.filter((item: any) => item.id !== id)]
                setProps(props.dialogKey, "selectedItems", filteredArray);

                /**if merchant close modal without submiting.. the items that 
                 * is main item should be remove automatically from list**/
                const { parentModalKey } = getProps(props.dialogKey);
                if (parentModalKey) {
                  setProps(parentModalKey, "selectedItems", filteredArray);
                }
              }
            }
          }, `${props.nextURL}${item.id}`, props.dialogKey)

        }
      };
      return (
        <>
          <EditIcon
            data-component-name="EDIT_ITEM_BUTTON"
            onClick={(event: MouseEvent<SVGSVGElement>) =>
              onClickEdit(event)
            }
            style={{
              marginLeft: "1rem", width: "1.25rem",
              height: "1.25rem",

            }}
          ></EditIcon>
          <PriceOptionDetailsTooltip
            id={menuItem?.id}
            venueId={props.venueId}
            isSquare={props.isSquare}
          />

          {checkIsOnlyMainItem(menuItem) && (
            <span
              style={{
                borderRadius: "0.875rem",
                border: "1px solid #C1CAE1",
                padding: "0.3125rem 0.625rem",
                color: "#AAB6D3",
                marginRight: "1.875rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <p style={{
                fontFamily: "Open Sans",
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: "0.8125rem",
                lineHeight: "1.125rem",
                margin: 0
              }}>
                {t("menu.extras.mainItem")}
              </p>
            </span>
          )}
        </>
      );
    }
  };
  function onListSubmit(selectedItems: ISearchableChecklistItem[]) {
    //@ts-ignore
    props.onSubmit(selectedItems, listItems);
    props.onDialogClose!();
  }
  const listProps = {
    ...props,
    onSubmit: onListSubmit,
    itemToolbar: props.hasToolbar ? Toolbar : undefined,
    listData: Items,
    mainLabelKey: props.propNameToDisplay ?? "name_public",
    onCancel: props.onDialogClose!,
    onCreate: props.onCreate ? (data: any) => {
      setProps(props.dialogKey, "selectedItems", data);
      //@ts-ignore
      props.onCreate(data);
    } : undefined
  };

  return isLoading ? (
    <FormLoadingWrapper><ListLoading /></FormLoadingWrapper>
  ) : (
    <>
      {/* @ts-ignore */}
      <AdvancedChecklist
        {...listProps}
      />
    </>
  );
}
